import { makeStyles } from '@material-ui/core'
import themesConfig from 'app/fuse-configs/themesConfig'
import { useBreakpoints } from 'commons/useBreakpoints'

export default makeStyles((theme) => ({
  title: {
    fontSize: 18,
    fontWeight: 500,
    lineHeight: '24px',
    marginBottom: 12,
    color: themesConfig.default.colors['neutrals-900'],
  },

  connectedSISWrap: {
    backgroundColor: themesConfig.default.colors['primary-lighter'],
    border: `1px solid ${themesConfig.default.colors['primary-350']}`,
    borderRadius: 7,
    padding: 16,
    [useBreakpoints(theme).lessThan.md]: {
      gap: 10,
    },
    [useBreakpoints(theme).lessThan.sm]: {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },

  SISName: {
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '20px',
    color: themesConfig.default.colors['neutrals-900'],
    marginLeft: 12,
  },

  SISLogo: {
    width: 87,
    height: 45,
    objectFit: 'contain',
  },

  infoTitle: {
    fontSize: 14,
    lineHeight: '20px',
    color: themesConfig.default.colors['neutrals-500'],
  },

  inProcessImportBtn: {
    opacity: 0.5,
    '&:hover': {
      opacity: 0.75,
    },
  },

  circularProgress: {
    marginRight: 10,
    color: themesConfig.default.colors['primary-lighter'],
  },
}))
